import {
  Button,
  ButtonGroup,
  Checkbox,
  DatePicker,
  DateRange,
  Modal,
  Select,
} from "@veneer/core";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import moment from "moment";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const theme = createTheme({
  palette: {
    primary: {
      main: "#027aae",
    },
  },
});

export const AgendaEditingBLock = (props: any) => {
  const {
    showModalEditAgendaPermanent,
    cancelEditAgendaPermanent,
    editAgendaButtonDisable,
    submitEditAgenda,
    handleChangeTypeOfVisit,
    typeofAppointmentData,
    typeOfVisit,
    onClearTypeOfVisit,
    handleChangeSubRetail,
    subretailData,
    subRetail,
    onClearSubRetail,
    setPointOfSale,
    pointOfSaleData,
    pointOfSale,
    errorPos,
    endDate,
    handleChangeStartDate,
    startDate,
    errorDatePicker,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    checkboxMonday,
    setCheckboxMonday,
    checkboxTuesday,
    setCheckboxTuesday,
    checkboxWednesday,
    setCheckboxWednesday,
    checkboxThursday,
    setCheckboxThursday,
    checkboxFriday,
    setcheckboxFriday,
    checkboxSaturday,
    setCheckboxSaturday,
    checkboxSunday,
    setCheckboxSunday,
    showModalEditAgendaVisit,
    cancelEditAgendaVisit,
    handleChangeVisitDate,
    visitDate,
  } = props;

  const [t] = useTranslation("global");

  return (
    <>
      {showModalEditAgendaPermanent && !showModalEditAgendaVisit && (
        <Modal
          closeButton={true}
          align="center"
          id="modalEditAgenda"
          show={showModalEditAgendaPermanent}
          onClose={cancelEditAgendaPermanent}
          footer={
            <ButtonGroup className="createAgendaButtongrouop">
              <Button
                disabled={editAgendaButtonDisable}
                onClick={submitEditAgenda}
              >
                {t("header.submit")}
              </Button>
              <Button
                onClick={cancelEditAgendaPermanent}
                appearance="secondary"
              >
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.editAgenda")}
        >
          <div className="createAgenda">
            <Select
              className="createAgendaSelect"
              label={t("header.typeOfVisit")}
              onChange={(e) => handleChangeTypeOfVisit(e.value)}
              options={typeofAppointmentData}
              value={typeOfVisit}
              onClear={() => onClearTypeOfVisit()}
              disabled={true}
              readOnly
            />

            <div className="createAgendaPermanent">
              <Select
                className="createAgendaSelect"
                label={t("header.subRetail")}
                onChange={(e) => handleChangeSubRetail(e.value)}
                options={subretailData}
                value={subRetail}
                onClear={() => onClearSubRetail()}
                disabled={true}
                readOnly
              />
              <Select
                className="createAgendaSelect"
                label={t("header.pointOfSale")}
                onChange={(e) => setPointOfSale([e.value])}
                options={pointOfSaleData}
                value={pointOfSale}
                onClear={() => setPointOfSale([])}
                disabled={true}
                readOnly
                error={errorPos}
              />

              <DatePicker
                className="createAgendaDatePicker"
                blockPastDates
                clearIcon={false}
                endDate={endDate}
                onChange={(date) => handleChangeStartDate(date as DateRange)}
                orientation="horizontal"
                range
                startDatePlaceholder="mm/dd/yyyy"
                endDatePlaceholder="mm/dd/yyyy"
                format="LL"
                startDate={startDate}
                startDateLabel={t("header.stardDate")}
                endDateLabel={t("header.endDate")}
                maxDate={moment(startDate).add(12, "months")}
                minimumNights={1}
                error={errorDatePicker}
              />

              <div className="createAgendaTimes">
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <ThemeProvider theme={theme}>
                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.startTime")}
                      value={startTime}
                      onChange={(value) => setStartTime(value)}
                      renderInput={(params) => <TextField {...params} />}
                      minutesStep={10}
                      ampm={false}
                    />

                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.endTime")}
                      value={endTime}
                      onChange={(value) => setEndTime(value)}
                      renderInput={(params) => <TextField {...params} />}
                      minutesStep={10}
                      ampm={false}
                    />
                  </ThemeProvider>
                </LocalizationProvider>
              </div>

              <div className="createAgendaDays">
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.monday")}
                  value={checkboxMonday}
                  checked={checkboxMonday}
                  onChange={() => setCheckboxMonday(!checkboxMonday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.tuesday")}
                  value={checkboxTuesday}
                  checked={checkboxTuesday}
                  onChange={() => setCheckboxTuesday(!checkboxTuesday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.wednesday")}
                  value={checkboxWednesday}
                  checked={checkboxWednesday}
                  onChange={() => setCheckboxWednesday(!checkboxWednesday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.thursday")}
                  value={checkboxThursday}
                  checked={checkboxThursday}
                  onChange={() => setCheckboxThursday(!checkboxThursday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.friday")}
                  value={checkboxFriday}
                  checked={checkboxFriday}
                  onChange={() => setcheckboxFriday(!checkboxFriday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.saturday")}
                  value={checkboxSaturday}
                  checked={checkboxSaturday}
                  onChange={() => setCheckboxSaturday(!checkboxSaturday)}
                />
                <Checkbox
                  className="createAgendaCheckbox"
                  label={t("header.sunday")}
                  value={checkboxSunday}
                  checked={checkboxSunday}
                  onChange={() => setCheckboxSunday(!checkboxSunday)}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {!showModalEditAgendaPermanent && showModalEditAgendaVisit && (
        <Modal
          closeButton={true}
          align="center"
          id="modalEditAgenda"
          show={showModalEditAgendaVisit}
          onClose={cancelEditAgendaVisit}
          footer={
            <ButtonGroup className="createAgendaButtongrouop">
              <Button
                disabled={editAgendaButtonDisable}
                onClick={submitEditAgenda}
              >
                {t("header.submit")}
              </Button>
              <Button onClick={cancelEditAgendaVisit} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.editAgenda")}
        >
          <div className="createAgenda">
            <Select
              className="createAgendaSelect"
              label={t("header.typeOfVisit")}
              onChange={(e) => handleChangeTypeOfVisit(e.value)}
              options={typeofAppointmentData}
              value={typeOfVisit}
              onClear={() => onClearTypeOfVisit()}
              disabled={true}
              readOnly
            />
            <div className="createAgendaVisit">
              <Select
                className="createAgendaSelect"
                label={t("header.subRetail")}
                onChange={(e) => handleChangeSubRetail(e.value)}
                options={subretailData}
                value={subRetail}
                onClear={() => onClearSubRetail()}
                disabled={true}
                readOnly
              />
              <Select
                className="createAgendaSelect"
                label={t("header.pointOfSale")}
                onChange={(e) => setPointOfSale([e.value])}
                options={pointOfSaleData}
                value={pointOfSale}
                onClear={() => setPointOfSale([])}
                disabled={true}
                readOnly
                error={errorPos}
              />

              <DatePicker
                className="createAgendaDatePicker"
                label={t("header.visitDate")}
                onChange={handleChangeVisitDate}
                clearIcon={false}
                value={visitDate}
                placeholder="mm/dd/yyyy"
                format="L"
                blockPastDates
              />
              <div className="createAgendaTimes">
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <ThemeProvider theme={theme}>
                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.startTime")}
                      value={startTime}
                      onChange={(value) => setStartTime(value)}
                      renderInput={(params) => <TextField {...params} />}
                      minutesStep={10}
                      ampm={false}
                    />

                    <TimePicker
                      className="createAgendaTimePicker"
                      label={t("header.endTime")}
                      minTime={startTime}
                      value={endTime}
                      onChange={(value) => setEndTime(value)}
                      renderInput={(params) => <TextField {...params} />}
                      minutesStep={10}
                      ampm={false}
                    />
                  </ThemeProvider>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
